(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nl-header"]) return;
  try {
    
(() => {
  const bind = root => {
    const shell = root.querySelector('.nl-navigation-shell');
    if (!shell || shell.dataset.navigationBound) return;
    shell.dataset.navigationBound = 'true';
    const entries = [...shell.querySelectorAll('.nl-mega')];
    const desktop = matchMedia('(min-width:990px)');
    const closeAll = except => entries.forEach(entry => { if (entry !== except) entry.open = false; });
    const closeShell = () => closeAll();
    entries.forEach(entry => {
      entry.addEventListener('toggle', () => { if (entry.open) closeAll(entry); });
      entry.addEventListener('pointerenter', event => { if (desktop.matches && event.pointerType === 'mouse') { closeAll(entry); entry.open = true; } });
      entry.addEventListener('focusout', event => { if (event.relatedTarget && !entry.contains(event.relatedTarget)) entry.open = false; });
    });
    shell.addEventListener('pointerleave', event => {
      if (desktop.matches && event.pointerType === 'mouse' && !entries.some(entry => entry.contains(document.activeElement))) closeAll();
    });
    shell.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const open = entries.find(entry => entry.open);
        if (open) { closeAll(); open.querySelector('summary').focus(); }
      }
    });
    document.addEventListener('click', event => { if (!shell.contains(event.target)) closeAll(); });
    desktop.addEventListener('change', closeShell);
    shell.querySelector('[data-nl-open-menu]').addEventListener('click', () => {
      const menu = document.getElementById('menuDialog');
      if (menu && !menu.open) menu.showModal();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(document));
  else bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nl-product"]) return;
  try {
    
function updateNewlandsProductSticky() {
  document.querySelectorAll('[data-nl-product] .product-photo').forEach(photo => {
    const header = document.querySelector('.header-shell');
    const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 100;
    const top = Math.min(headerBottom + 16, window.innerHeight - photo.offsetHeight - 20);
    photo.style.setProperty('--nl-photo-sticky-top', `${top}px`);
  });
}
const newlandsProductResizeObserver = new ResizeObserver(updateNewlandsProductSticky);
document.querySelectorAll('[data-nl-product] .product-photo, .header-shell').forEach(element => newlandsProductResizeObserver.observe(element));
window.addEventListener('resize', updateNewlandsProductSticky);
document.addEventListener('shopify:section:load', updateNewlandsProductSticky);
updateNewlandsProductSticky();

  } catch(e) { console.error(e); }
})();
})();
